import * as React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Grid } from '@material-ui/core';
import { RewardsAndOffersContext } from '../../../../contexts';
import { cards } from '../../../../constants/LegacyTiers';
var cardConstants = cards.PaintRewards;
var rewardsHistory = cardConstants.rewardsHistory;
var getPaintMembership = function (rewardsAndOffers) {
    var _a;
    return (_a = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.currentYearMemberships) === null || _a === void 0 ? void 0 : _a.find(function (membership) { return membership.programId === '2'; });
};
var SectionTitle = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "section-title" }, children));
};
var RenderSpendTiers = function () {
    var iconB = cardConstants.icon.BRONZE;
    var iconS = cardConstants.icon.SILVER;
    var iconG = cardConstants.icon.GOLD;
    var _a = { width: '29px', height: '34' }, width = _a.width, height = _a.height;
    var TierLabel = function (_a) {
        var children = _a.children, classes = _a.classes;
        return (React.createElement(Typography, { variant: "h4", weight: "display", component: "span" },
            React.createElement("span", { className: classes }, children)));
    };
    var TierRow = function (props) {
        var icon = props.icon, tier = props.tier, text = props.text, classes = props.classes;
        return (React.createElement(Grid, { className: "sui-flex sui-pb-4" },
            React.createElement(Grid, { item: true, xs: 4, sm: 3, className: "spend-tiers__icon-container" },
                React.createElement("img", { src: icon, alt: "icon-crown", width: width, height: height }),
                React.createElement(TierLabel, { classes: classes }, tier)),
            React.createElement(Grid, { item: true, xs: 8, sm: 9, className: "spend-tiers__item-container" },
                React.createElement("span", null, text))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "spend-tiers" },
            React.createElement(SectionTitle, null, rewardsHistory.spendTiers.title),
            React.createElement(TierRow, { icon: iconB, tier: "BRONZE", classes: "text-tiers-bronze", text: rewardsHistory.spendTiers.bronze }),
            React.createElement(TierRow, { icon: iconS, tier: "SILVER", classes: "text-tiers-silver", text: rewardsHistory.spendTiers.silver }),
            React.createElement(TierRow, { icon: iconG, tier: "GOLD", classes: "text-tiers-gold", text: rewardsHistory.spendTiers.gold }))));
};
var RenderAdjustmentHistory = function () {
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var paintResponse = getPaintMembership(rewardsAndOffers);
    var history = paintResponse && (paintResponse === null || paintResponse === void 0 ? void 0 : paintResponse.tierAdjustmentHistory);
    var headers = rewardsHistory.adjustmentHistory.columns.map(function (arr) { return (React.createElement(React.Fragment, null,
        arr[0],
        !!arr[1] && React.createElement("br", null),
        !!arr[1] && arr[1])); });
    var HistoryRow = function (_a) {
        var isHeader = _a.isHeader, columns = _a.columns;
        var rowClass = isHeader ? 'header' : 'row';
        return (React.createElement("div", { className: "adjustment-history__".concat(rowClass) },
            React.createElement("span", null, columns[0]),
            React.createElement("span", null, columns[1]),
            React.createElement("span", null, columns[2])));
    };
    return !history ? (React.createElement(React.Fragment, null)) : (React.createElement("div", { className: "adjustment-history" },
        React.createElement(SectionTitle, null, rewardsHistory.adjustmentHistory.title),
        React.createElement("div", { className: "adjustment-history__table sui-w-full" },
            React.createElement(HistoryRow, { isHeader: true, columns: headers }), history === null || history === void 0 ? void 0 :
            history.map(function (obj, i) {
                var data = [obj.effectiveDate, obj.tierAdjustment, obj.description];
                return React.createElement(HistoryRow, { columns: data, key: i });
            }))));
};
var RenderQualificationDetails = function (_a) {
    var isMobile = _a.isMobile;
    var Para = function (_a) {
        var children = _a.children;
        return (React.createElement("span", { className: "qualification-details__paragraph" }, children));
    };
    return (React.createElement("div", { className: "qualification-details" },
        React.createElement(SectionTitle, null, rewardsHistory.qualificationDetails.title),
        React.createElement(Typography, { align: "left", variant: "body-base" },
            React.createElement(Para, null, rewardsHistory.qualificationDetails.paragraphs[0]),
            !isMobile && (React.createElement(React.Fragment, null,
                React.createElement(Para, null, rewardsHistory.qualificationDetails.paragraphs[1]),
                React.createElement(Para, null, rewardsHistory.qualificationDetails.paragraphs[2]))))));
};
export var RewardsHistoryDTW = function (props) {
    var section = props.section;
    switch (section) {
        case 'header':
            return React.createElement(React.Fragment, null, rewardsHistory.title);
        case 'body':
            return (React.createElement("div", { className: "paint-history-modal" },
                React.createElement(RenderSpendTiers, null),
                React.createElement(RenderAdjustmentHistory, null),
                React.createElement(RenderQualificationDetails, null)));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export var RewardsHistoryMW = function (props) {
    var section = props.section;
    switch (section) {
        case 'header':
            return React.createElement(React.Fragment, null, rewardsHistory.title);
        case 'body':
            return (React.createElement("div", { className: "paint-history-modal" },
                React.createElement(RenderSpendTiers, null),
                React.createElement(RenderAdjustmentHistory, null),
                React.createElement(RenderQualificationDetails, { isMobile: true })));
        default:
            return React.createElement(React.Fragment, null);
    }
};
